import React from 'react';

import { formatMilliCentsValue } from 'utils/table/currency';

import * as S from './styles';

interface RemainingBudgetIndicatorProps {
  remainingBudgetMilliCents: number;
}

const RemainingBudgetIndicator: React.FunctionComponent<
  RemainingBudgetIndicatorProps
> = (props) => {
  const { remainingBudgetMilliCents } = props;

  return (
    <S.RemainingBudgetContainer>
      <S.RemainingBudgetTypography>
        ${formatMilliCentsValue(remainingBudgetMilliCents, 2, true)} remaining
      </S.RemainingBudgetTypography>
    </S.RemainingBudgetContainer>
  );
};

export default RemainingBudgetIndicator;
